import React from 'react';
import { connect } from 'react-redux';
import WishlistPopup from './WishlistPopup';
import { signInCheck } from '../../common/CheckUserStatus';
import { showModal } from '../../../actions/modal.js';
import { readCookie } from '../../common/Cookie';
import { generateEvent } from '../../../utils/dataGrinch';
import properties from '../../../modules/ajio-util/properties';
import { getIconStyles } from '../../../utils/common';
import { gtmEventPush, gtmEventPushPLP, segmentEventPush } from '../../../modules/ga/GTMdatalayer';

class Wishlist extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isMouseInside: false };
    this.mouseEnter = this.mouseEnter.bind(this);
    this.mouseExit = this.mouseExit.bind(this);
  }

  linkClick(link, name) {
    generateEvent({
      Event: 'HeaderClick',
      value: {
        LinkName: name,
        LinkUrl: link,
        Screen: 'Desktop'
      }
    });

    gtmEventPushPLP({
      event: 'plp_navigation_interaction',
      event_category: 'plp_interaction',
      event_action: 'wishlist click',
      event_label: 'wishlist',
      store_type: 'ajio',
      page_type: window.pageType || ''
    }, 'plp_navigation_interaction', true);
    //window.location = link;

    gtmEventPush({
      event: 'buttonTap',
      event_category: 'buttonTap',
      event_action: 'Header Click',
      event_label: 'Closet Button'
    });

    // Segment Push Event
    segmentEventPush({
      event: 'Header Nav Clicked',
      event_category: 'buttonTap',
      event_action: 'Header Click',
      event_label: 'Closet Button',
      //active_notification: counter,
      bag_item_count: this.props.counter?.cartCount,
      component_name:'Wishlist',
      screen_name:'wishlist'      
      
    });
  }

  mouseEnter() {
    this.setState({ isMouseInside: true });
  }

  mouseExit() {
    this.setState({ isMouseInside: false });
  }

  render() {
    const wishlist = this.props.showWishlist;
    let {
      metaData: { sis = false, current: { headerIconColor, buttonPatchColor } = {} } = {},
      newDesignLuxe,
      isStreetStore
    } = this.props;
    let isSignedIn = signInCheck();
    const iconStyles = getIconStyles({
      headerIconColor,
      buttonPatchColor
    });
    const imageBaseUrl = properties.getProperty('imageBaseUrl');
    return (
      <div
        aria-label='wishlist icon'
        className={!newDesignLuxe ? 'popup-blk wishlist-blk-icon' : 'popup-blk wishlist-blk'}
        onMouseEnter={this.mouseEnter}
        onMouseLeave={this.mouseExit}
        onFocus={this.mouseEnter}
        onBlur={this.mouseExit}
      >
        {isSignedIn ? (
          <a
            tabIndex={0}
            href={
              sis && !newDesignLuxe && !isStreetStore
                ? `${properties.getProperty('parentUrl')}/wishlist`
                : '/wishlist'
            }
            onClick={() => {
              this.linkClick('/wishlist', 'WishlistClick');
            }}
            aria-label='wishlist icon'
          >
            {!newDesignLuxe ? (
              <img aria-label='wishlist icon' src={`${imageBaseUrl}/static/img/wishlistIcon.svg`} alt="Wishlist icon" />
            ) : (
              <div aria-label='wishlist icon' className="ic-wishlist" style={iconStyles} />
            )}
          </a>
        ) : !newDesignLuxe ? (
          <img
            tabIndex={0}
            src={`${imageBaseUrl}/static/img/wishlistIcon.svg`}
            aria-label="wishlist icon"
            alt="Wishlist icon"
            onClick={() => {
              this.linkClick('/wishlist', 'WishlistClick');
              this.props.showModal('sign-in-up');
              this.setState({ isMouseInside: false });
            }}
          />
        ) : (
          <div
            tabIndex={0}
            className="ic-wishlist"
            aria-label="wishlist icon"
            onClick={() => {
              this.linkClick('/wishlist', 'WishlistClick');
              this.props.showModal('sign-in-up');
              this.setState({ isMouseInside: false });
            }}
            style={iconStyles}
          />
        )}
        {wishlist ? <WishlistPopup newDesignLuxe={newDesignLuxe} /> : null}
        {!isSignedIn && this.state.isMouseInside ? (
          <div className="small-popup login-closet" tabIndex={0}>
            <div className={newDesignLuxe ? 'ic-toparw' : 'ic-toparw ic-toparw-mr'} tabIndex={0}/>
            <div className="popup-inner" tabIndex={0}>
              <span
                onClick={() => {
                  this.props.showModal('sign-in-up');
                  this.setState({ isMouseInside: false });
                }}
                className="wishlist-login"
                tabIndex={0}
              >
                SIGN IN
              </span>
              <div className="wishlist-msg" tabIndex={0}>To add or view item(s) part of your wishlist</div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    showWishlist: state.popup.showWislistPopup,
    metaData: state.metaData,
    counter: state.counter,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    showModal: (name, config) => {
      dispatch(showModal(name, config));
    }
  };
};

export default Wishlist = connect(mapStateToProps, mapDispatchToProps)(Wishlist);
